import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import './styles/CircleWidget.scss';
import messages from './messages/CircleWidget_messages';

export function renderPersonnelCircle(personnelData, label) {
  const pclass = personnelData.class;

  let percentage = 0;
  let iconText = <FormattedMessage {...messages.notKnown} info="Not known" />;
  let knownClass = true;

  if (pclass === 1) {
    iconText = '1-4';
    percentage = 17;
  } else if (pclass === 2) {
    iconText = '5-9';
    percentage = 33;
  } else if (pclass === 3) {
    iconText = '10-19';
    percentage = 50;
  } else if (pclass === 4 || pclass === 5) {
    iconText = '20-99';
    percentage = 67;
  } else if (pclass === 6 || pclass === 7) {
    iconText = '100-499';
    percentage = 83;
  } else if (pclass > 7) {
    iconText = '500+';
    percentage = 100;
  } else {
    knownClass = false;
  }

  /* eslint-disable quote-props */
  const iconClasses = classNames('circle-icon-small', {
    'circle-icon-gray': !knownClass,
  });

  const iconTextClasses = classNames({
    'circle-icon-text': true,
    'circle-icon-gray': !knownClass,
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper">
      <div styleName="circle-icon-header">{label}</div>
      <div
        styleName="circle-fillable"
        className="circle-fillable"
        data-percentage={percentage}
      >
        <div styleName="circle-fillable-inner">
          <i styleName={iconClasses} className="fa fa-user" />
          <span styleName={iconTextClasses}>{iconText}</span>
        </div>
      </div>
    </div>
  );
}

export function renderAgeCircle(ageData, label) {
  const YEAR_IN_DAYS = 365;
  const age = ageData;

  let percentage = 0;
  let iconText = <FormattedMessage {...messages.notKnown} info="Not known" />;
  let knownClass = false;

  if (age !== null) {
    if (age < YEAR_IN_DAYS) {
      knownClass = true;
      iconText = '< 1';
      percentage = 20;
    } else if (age < 3 * YEAR_IN_DAYS) {
      knownClass = true;
      iconText = '1-3';
      percentage = 40;
    } else if (age < 5 * YEAR_IN_DAYS) {
      knownClass = true;
      iconText = '3-5';
      percentage = 60;
    } else if (age < 10 * YEAR_IN_DAYS) {
      knownClass = true;
      iconText = '5-9';
      percentage = 80;
    } else if (age >= 10 * YEAR_IN_DAYS) {
      knownClass = true;
      iconText = '10+';
      percentage = 100;
    }
  }

  const iconTextClasses = classNames({
    'circle-icon-large-text': knownClass,
    'circle-icon-text': !knownClass,
    'circle-icon-gray': !knownClass,
  });


  return (
    <div styleName="circle-icon-wrapper">
      <div styleName="circle-icon-header">{label}</div>
      <div
        styleName="circle-fillable"
        className="circle-fillable"
        data-percentage={percentage}
      >
        <div styleName="circle-fillable-inner">
          <div styleName={iconTextClasses}>
            {iconText}
          </div>
          {knownClass && (
            <span styleName="circle-icon-text">
              <FormattedMessage {...messages.years} info="Years" />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export function renderTurnoverCircle(turnoverData, label) {
  const tclass = turnoverData.class;

  let percentage = 0;
  let iconText = <FormattedMessage {...messages.notKnown} info="Not known" />;
  let knownClass = true;

  if (tclass === 3 || tclass === 2) {
    iconText = '< 0.2';
    percentage = 17;
  } else if (tclass === 4) {
    iconText = '0.2-0.4';
    percentage = 33;
  } else if (tclass === 5 || tclass === 6) {
    iconText = '0.4-2';
    percentage = 50;
  } else if (tclass === 7) {
    iconText = '2-10';
    percentage = 67;
  } else if (tclass === 8) {
    iconText = '10-19';
    percentage = 83;
  } else if (tclass === 9) {
    iconText = '20+';
    percentage = 100;
  } else {
    knownClass = false;
  }

  /* eslint-disable quote-props */
  const iconClasses = classNames({
    'circle-icon-large-text': knownClass,
    'circle-icon-text': !knownClass,
    'circle-icon-gray': !knownClass,
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper">
      <div styleName="circle-icon-header">{label}</div>
      <div
        styleName="circle-fillable"
        className="circle-fillable"
        data-percentage={percentage}
      >
        <div styleName="circle-fillable-inner">
          <div styleName={iconClasses}>{iconText}</div>
          {knownClass && (
            <div styleName="circle-icon-text">m€</div>
          )}
        </div>
      </div>
    </div>
  );
}

export function renderVatCircle(registrations) {
  const { vat } = registrations;

  let headerText = (
    <FormattedMessage {...messages.notAvailable} info="Not available" />
  );

  if (vat) {
    headerText = (
      <FormattedMessage
        {...messages.VATVisible}
        info="VAT visible on receipt"
      />
    );
  } else if (vat === false) {
    // If null, then use "messages.notAvailable"
    headerText = (
      <FormattedMessage
        {...messages.VATNotVisible}
        info="VAT not visible on receipt"
      />
    );
  }
  /* eslint-disable quote-props */
  const iconClasses = classNames({
    'circle-icon': true,
    'circle-icon-gray': !registrations.vat,
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper animated bounceIn">
      <div styleName="circle-icon-header">
        {headerText}
      </div>
      <div styleName={iconClasses}>
        <i
          styleName="circle-icon-medium"
          className="fa fa-percent"
        />
      </div>
    </div>
  );
}

export function renderEmployerCircle(registrations) {
  const { employer } = registrations;
  const isChecked = employer === 'yes' || employer === 'yes_small';

  let headerText = (
    <FormattedMessage {...messages.notAvailable} info="Not available" />
  );
  if (employer === 'yes' || employer === 'yes_small') {
    headerText = (
      <FormattedMessage {...messages.hiredEmployees} info="Hired employees" />
    );
  } else if (employer === 'no') {
    /* eslint-disable max-len */
    headerText = (
      <FormattedMessage
        {...messages.hiredEmployeesNotRegistered}
        info="Hired employees but not registered in employers register"
      />
    );
    /* eslint-enable max-len */
  } else if (employer === 'no_small') {
    headerText = (
      <FormattedMessage
        {...messages.atMostTwoEmployees}
        info="At most two employees"
      />
    );
  }

  /* eslint-disable quote-props */
  const iconClasses = classNames({
    'circle-icon': true,
    'circle-icon-gray': !isChecked,
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper animated bounceIn">
      <div styleName="circle-icon-header">{headerText}</div>
      <div styleName={iconClasses}>
        <i
          styleName="circle-icon-medium"
          className="fa fa-users"
        />
      </div>
    </div>
  );
}

export function renderTaxPrepaymentCircle(registrations) {
  /* eslint-disable camelcase */
  const { tax_prepayment } = registrations;

  let headerText = (
    <FormattedMessage {...messages.notAvailable} info="Not available" />
  );
  if (tax_prepayment === 'no') {
    headerText = (
      <FormattedMessage
        {...messages.cannotGetTaxPrepayment}
        info="Cannot get tax prepayment"
      />
    );
  } else if (tax_prepayment === 'yes') {
    headerText = (
      <FormattedMessage
        {...messages.canGetTaxPrepayment}
        info="Can get tax prepayment"
      />
    );
  } else if (tax_prepayment === 'no_override') {
    headerText = (
      <FormattedMessage
        {...messages.cannotGetTaxPrepaymentByOverride}
        info="Cannot get tax prepayment according to the company"
      />
    );
  }

  /* eslint-disable quote-props */
  const iconClasses = classNames({
    'circle-icon': true,
    'circle-icon-gray': tax_prepayment !== 'yes',
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper animated bounceIn">
      <div styleName="circle-icon-header">{headerText}</div>
      <div styleName={iconClasses}>
        <i styleName="circle-icon-medium" className="fa fa-home" />
      </div>
    </div>
  );
  /* eslint-enable camelcase */
}

export function renderAccidentCircle(insurances) {
  const { accident } = insurances;

  let headerText = (
    <FormattedMessage
      {...messages.noAccidentInsuranceInfo}
      info="No info about accident insurance"
    />
  );
  if (accident === 'no_small' || accident === 'no_large') {
    headerText = (
      <FormattedMessage
        {...messages.noAccidentInsurance}
        info="No accident insurance"
      />
    );
  } else if (accident === 'yes') {
    headerText = (
      <FormattedMessage
        {...messages.hasAccidentInsurance}
        info="Has accident insurance"
      />
    );
  }

  /* eslint-disable quote-props */
  const iconClasses = classNames({
    'circle-icon': true,
    'circle-icon-gray': accident !== 'yes',
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper animated bounceIn">
      <div styleName="circle-icon-header">{headerText}</div>
      <div styleName={iconClasses}>
        <img
          styleName="circle-icon-image"
          alt="Accident insurance logo"
          src={
            accident === 'yes'
              ? '/selvitys/images/tapaturmavakuutus.png'
              : '/selvitys/images/tapaturmavakuutus_off.png'
          }
        />
      </div>
    </div>
  );
}

export function renderLiabilityCircle(insurances) {
  const { liability } = insurances;

  let headerText = (
    <FormattedMessage
      {...messages.noLiabilityInsuranceInfo}
      info="No info about liability insurance"
    />
  );
  if (liability === 'no') {
    headerText = (
      <FormattedMessage
        {...messages.noLiabilityInsurance}
        info="No liability insurance"
      />
    );
  } else if (liability === 'yes') {
    headerText = (
      <FormattedMessage
        {...messages.hasLiabilityInsurance}
        info="Has liability insurance"
      />
    );
  }

  /* eslint-disable quote-props */
  const iconClasses = classNames({
    'circle-icon': true,
    'circle-icon-gray': liability !== 'yes',
  });
  /* eslint-enable quote-props */

  return (
    <div styleName="circle-icon-wrapper animated bounceIn">
      <div styleName="circle-icon-header">{headerText}</div>
      <div styleName={iconClasses}>
        <img
          styleName="circle-icon-image"
          alt="Liability insurance logo"
          src={
            liability !== 'yes'
              ? '/selvitys/images/vastuuvakuutus_off.png'
              : '/selvitys/images/vastuuvakuutus.png'
          }
        />
      </div>
    </div>
  );
}

export function renderElectricalInstallationCircle() {
  return (
    <div styleName="circle-icon-wrapper">
      <div styleName="circle-icon-header">
        <FormattedMessage
          {...messages.homeElectricityInstallation}
          info="Home electricity installations"
        />
      </div>
      <div styleName="circle-icon">
        <i styleName="circle-icon-large" className="fa fa-bolt" />
      </div>
    </div>
  );
}
